import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from "../card";
import { H3, H2 } from "../text";
import { styled } from "../theme";
/**
 * A component to display an error message.
 *
 * @param {object} props The props for the component.
 * @param {ReactNode} props.title The title of the error message.
 * @param {ReactNode} props.message The content of the error message.
 * @returns {JSX.Element} The rendered error message component.
 */
export const ErrorMessage = ({ title, message, }) => (_jsxs(Message, { children: [_jsx(H2, { color: "orange100", children: title }), _jsx(H3, { children: message })] }));
const Message = styled(Card) `
  border: 2px solid ${({ theme }) => theme.color.orange100};
`;
